import { SearchRepository, ISearchParams } from "@/repositories/search.repository"

export const SearchService = {
    Get: (params: ISearchParams, url: string = "/search/get") => SearchRepository.Get(params, url),
}